<template>
    <div class="filter-subscription-price-box px-3 position-relative">
        <filter-slider-box
            filter-title="price"
            :append-content="$t('cat.filter.currency')"
            :title="$t('cat.filter.price')"
            :show-title="true"
        ></filter-slider-box>
    </div>
</template>

<script>
import FilterSliderBox from "./FilterSliderBox.vue";

export default {
    name: 'FilterSubscriptionPriceBox',
    components: {
        FilterSliderBox,
    }
}
</script>
